import { render, staticRenderFns } from "./prohibitedArticles.vue?vue&type=template&id=bb0abed8"
import script from "./prohibitedArticles.vue?vue&type=script&lang=js"
export * from "./prohibitedArticles.vue?vue&type=script&lang=js"
import style0 from "./prohibitedArticles.vue?vue&type=style&index=0&id=bb0abed8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports